import { render, staticRenderFns } from "./UserViewAction.vue?vue&type=template&id=77fa5206"
import script from "./UserViewAction.vue?vue&type=script&lang=js"
export * from "./UserViewAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports